export const FAVORITES_PAGE_URL_ID = 'ma:myFavorites'
